import moment from 'moment';
import Vue from 'vue';
import Workout from '../lib/workout/Workout';

export default {
  state: {
    members: {},
  },
  mutations: {
    addTrainingPlans(state, payload) {
      if (!state.members) {
        Vue.set(state, 'members', {});
      }
      if (!state.members[payload.memberId]) {
        Vue.set(state.members, payload.memberId, []);
      }
      state.members[payload.memberId].push(...payload.trainingPlans);
    },
    clearTrainingPlans(state, payload) {
      if (payload && payload.memberId) {
        if (state.members && state.members[payload.memberId]) {
          state.members[payload.memberId].length = 0;
        }
      } else {
        // remove everything
        state.members = {};
      }
    },
  },
  getters: {
    trainingPlansByMemberId: state => (memberId) => {
      if (!state.members || !state.members[memberId]) {
        return [];
      }

      return state.members[memberId];
    },
    trainingPlanByMemberIdAndPlanId: state => (memberId, trainingPlanId) => {
      if (!state.members || !state.members[memberId]) {
        return null;
      }

      let tp = state.members[memberId]
        .find(trainingPlan => trainingPlan.trainingPlanId === trainingPlanId);
      if (tp) {
        tp = new Workout(tp);
      }
      return tp;
    },
    trainingPlansByMemberIdAndDate: state => (memberId, momentDate) => {
      if (!state.members || !state.members[memberId]) {
        return [];
      }

      const format = 'YYYY-MM-DD';

      return state.members[memberId]
        .filter(
          trainingPlan => moment(trainingPlan.training_plan_date)
            .format(format) === momentDate.format(format),
        )
        .map(trainingPlan => new Workout(trainingPlan));
    },
  },
  actions: {
    async loadTrainingPlans({ commit, getters }, { memberId, useCachedValues }) {
      if (useCachedValues) {
        const currentTrainingPlans = getters.trainingPlansByMemberId(memberId);
        if (currentTrainingPlans && currentTrainingPlans.length) {
          return;
        }
      }

      const res = await this.$container.dao.getTrainingPlans(
        moment().subtract(365, 'days').format('YYYYMMDD'),
        moment().add(365, 'days').format('YYYYMMDD'),
        memberId,
      );

      const trainingPlans = res.data.training_plans;
      commit('clearTrainingPlans', { memberId });
      commit('addTrainingPlans', { memberId, trainingPlans });
    },
    saveTrainingPlan(context, payload) {
      return this.$container.dao.saveTrainingPlan(
        payload.diaryDate,
        payload.plan,
        payload.diaryMemberId,
        payload.modifiedByMemberId,
        payload.removedByMemberId,
      );
    },
    clearTrainingPlans(context, payload) {
      context.commit('clearTrainingPlans', payload);
    },
  },
};
